<template>
  <div>
    <LmListV2
      ref='LmCodificatorBuilderListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado Codificadores Builder Internos',
      gqlField: 'CodificatorBuilder',
      gqlVariables: {
        q: 'deleted: false',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[CodificatorBuilderESSortEnum]) {
          CodificatorBuilder(
            titleList: "Listado Codificadores Builder Internos"
            q: $q
            perPage: 10
            page: $page
            sort: $sort
            metaSearch: "*"
            opts: {
                lenient: true
            }
            lmPathActions: [{to:"/listbuilder/view/:listbuilderId/",tooltip:" Ver",fontAwesomeIcon:"search"},{to:"/codificadoresbuilder/editar/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
            lmModalActions: []
            buttonLinks: [{value:"Nuevo",to:"/codificadoresbuilder/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info"}]\
            ) {
            count
            searcher
            tableItemsTotal
            titleList
            table {
                items {
                    codificatorName,createdAt,updatedAt,actions
                }
                fields {
                    key
                    label
                    sortable
                }
            }
            buttons
            pagination
        }
    }`,
      searchOnFieldsSelected: [
        'codificatorName',
        'createdAt',
        'updatedAt',
        'listbuilderId',
        'actions'
      ],
      searchOnFieldsToSelected: [
        'codificatorName',
        'createdAt',
        'updatedAt',
        'actions'],
      items: [
        {
          name: 'codificatorName'
        },
        {
          name: 'createdAt'
        },
        {
          name: 'updatedAt'
        },
        {
          name: 'listbuilderId'
        },
        {
          name: 'deleted'
        },
        {
          name: 'formbuilderId'
        },
        {
          name: 'isChild'
        },
        {
          name: 'lumbreInternal'
        },
        {
          name: 'createdBy'
        },
        {
          name: 'updatedBy'
        },
        {
          name: 'actions'
        }
      ],
      mode: {
        table: true,
        map: false
      },
      fields: [{
        key: 'codificatorName',
        label: 'Nombre',
        sortable: false
      }, {
        key: 'createdAt',
        label: 'Creado',
        sortable: true
      }, {
        key: 'updatedAt',
        label: 'Actualizado',
        sortable: true
      }, {
        key: 'actions',
        label: 'Acciones',
        sortable: false
      }]
    }
  }
}
</script>
